/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { MemberBankPaginationResponseDto } from '../model/memberBankPaginationResponseDto';
import { MemberBankRequestDto } from '../model/memberBankRequestDto';
import { MemberBankResponseDto } from '../model/memberBankResponseDto';
import { MemberDropdownResponseDto } from '../model/memberDropdownResponseDto';
import { MemberPaginationResponseDto } from '../model/memberPaginationResponseDto';
import { MemberRequestDto } from '../model/memberRequestDto';
import { MemberResponseDto } from '../model/memberResponseDto';
import { ValidationError } from '../model/validationError';

export enum membersBankDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum membersBankGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum membersDropdownGetEntityTypeEnum {
  individual = 'individual',
  corporate = 'corporate',
}
export enum membersDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum membersGetEntityTypeEnum {
  individual = 'individual',
  corporate = 'corporate',
}
export enum membersGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum membersIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class MembersService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public membersBankDropdownGet$(page?: number, limit?: number, memberId?: string, language?: string): Observable<Array<MemberBankResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/members/bank/dropdown`, { page, limit, memberId, language });
  }
  /**
   * [Authorize] type: http
   */
  public membersBankGet$(page?: number, limit?: number, memberId?: string, language?: string): Observable<MemberBankPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/members/bank`, { page, limit, memberId, language });
  }
  /**
   * [Authorize] type: http
   */
  public membersBankIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/members/bank/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public membersBankIdPut$(id: string, body: MemberBankRequestDto): Observable<MemberBankResponseDto> {
    return this.api.put(`${apiBaseUrl()}/members/bank/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public membersBankPost$(body: MemberBankRequestDto): Observable<MemberBankResponseDto> {
    return this.api.post(`${apiBaseUrl()}/members/bank`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public membersDropdownGet$(page?: number, limit?: number, memberTierId?: string, entityType?: string, name?: string, cid?: string, phone?: string, isActive?: boolean, language?: string, memberNo?: string, countBank?: boolean, sort?: string): Observable<Array<MemberDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/members/dropdown`, { page, limit, memberTierId, entityType, name, cid, phone, isActive, language, memberNo, countBank, sort });
  }
  /**
   * [Authorize] type: http
   */
  public membersGet$(page?: number, limit?: number, memberTierId?: string, entityType?: string, name?: string, cid?: string, phone?: string, isActive?: boolean, language?: string, memberNo?: string, countBank?: boolean, sort?: string): Observable<MemberPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/members`, { page, limit, memberTierId, entityType, name, cid, phone, isActive, language, memberNo, countBank, sort });
  }
  /**
   * [Authorize] type: http
   */
  public membersIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/members/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public membersIdGet$(id: string, language?: string): Observable<MemberResponseDto> {
    return this.api.get(`${apiBaseUrl()}/members/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public membersIdPut$(id: string, body: MemberRequestDto): Observable<MemberResponseDto> {
    return this.api.put(`${apiBaseUrl()}/members/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public membersIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/members/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public membersPost$(body: MemberRequestDto): Observable<MemberResponseDto> {
    return this.api.post(`${apiBaseUrl()}/members`, body, undefined);
  }
}
